import { SourceHTMLAttributes, ImgHTMLAttributes, forwardRef } from 'react';

export interface PictureFormats {
  avif?: SourceHTMLAttributes<HTMLSourceElement>;
  webp?: SourceHTMLAttributes<HTMLSourceElement>;
  jpg: ImgHTMLAttributes<HTMLImageElement>;
}

export type PictureProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'alt'> & {
  formats: PictureFormats;
};

export const Picture = forwardRef<HTMLImageElement, PictureProps>(
  ({ formats: { avif, webp, jpg }, ...rest }: PictureProps, ref) => (
    <picture>
      {avif !== undefined && <source {...avif} />}
      {webp !== undefined && <source {...webp} />}
      <img
        ref={ref}
        {...jpg}
        alt={jpg.alt}
        {...rest}
        style={{
          ...jpg.style,
          ...rest.style,
        }}
      />
    </picture>
  )
);
